import { render } from "./GroupsList.vue?vue&type=template&id=1d77347a"
import script from "./GroupsList.vue?vue&type=script&lang=js"
export * from "./GroupsList.vue?vue&type=script&lang=js"

import "./GroupsList.vue?vue&type=style&index=0&id=1d77347a&lang=css"

import exportComponent from "/go/src/asuzs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__